export function normalizePhoneNumber(phoneNumber: string): string {
  let number = phoneNumber;
  number = number.replace(/[^\d+]+/g, '');
  number = number.replace(/^00/, '+');
  if (/^1/.test(number)) number = `+${number}`;
  if (!/^\+/.test(number)) number = `+1${number}`;
  return number;
}
